import { safeLocalStorage } from '@utils/common';

const localStorageKey = "pm2:skin__course-builder-panel-was-opened";
function showOnboardingOnMount() {
  return safeLocalStorage.getItem(localStorageKey) !== "true";
}
function markOnboardingAsCompleted() {
  safeLocalStorage.setItem(localStorageKey, "true");
}

export { markOnboardingAsCompleted, showOnboardingOnMount };
//# sourceMappingURL=_onboarding.utils.js.map
